import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-041f3133")

_pushScopeId("data-v-041f3133")
const _hoisted_1 = { class: "m-image-preview" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_space = _resolveComponent("el-space")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_space, { wrap: "" }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imgList, (img) => {
          return (_openBlock(), _createBlock("div", {
            class: "img",
            key: img
          }, [
            _createVNode(_component_el_image, {
              src: img,
              "preview-src-list": _ctx.imgList,
              size: 16,
              lazy: "",
              fit: "contain"
            }, null, 8, ["src", "preview-src-list"])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
})